import axios from 'axios';
import API_HOST from '../api';

const sopApi = function() {
  const api = {};

  api.getClientList = function(clientId) {
    return axios.get(`${API_HOST}/api/sop/client/${clientId}/page-list`);
  };

  api.getPage = function(clientId, pageId, version, format = 'html') {
    let url = `${API_HOST}/api/sop/client/${clientId}/page/${pageId}?format=${format}`;
    if (version && version !== -1) {
      url = `${url}&version=${version}`;
    }

    return axios.get(url);
  };

  api.updatePage = function(clientId, pageId, page, comment) {
    const updateBody = {
      comment,
      default: true,
      content: page.content,
      title: page.title,
    };

    if (!updateBody.title) updateBody.title = 'Default Title';

    return axios.post(`${API_HOST}/api/sop/client/${clientId}/page/${pageId}`, updateBody);
  };

  api.updateListOrder = function(clientId, ids) {
    return axios.post(`${API_HOST}/api/sop/client/${clientId}/page-list`, ids);
  };

  api.createPage = function(clientId, page, comment) {
    const updateBody = {
      comment,
      default: true,
      content: page.content,
      title: page.title,
    };
    return axios.post(`${API_HOST}/api/sop/client/${clientId}`, updateBody);
  };

  api.archivePage = function(clientId, pageId) {
    return axios.post(`${API_HOST}/api/sop/client/${clientId}/page/${pageId}/archive`);
  };

  api.unArchivePage = function(clientId, pageId) {
    return axios.post(`${API_HOST}/api/sop/client/${clientId}/page/${pageId}/unarchive`);
  };

  api.getPagePreview = function(markdown) {
    return axios.post(`${API_HOST}/api/sop/preview`, { markdown });
  };

  api.getPageVersions = function(clientId, pageId) {
    return axios.get(`${API_HOST}/api/sop/client/${clientId}/page/${pageId}/version-list`);
  };

  return api;
};


export default sopApi();
